<template>
  <div>
    <cabecalho :ar="ar"></cabecalho>
    <div class="app-content">
      <div class="heading">Solicitação de certificado digital</div>
      <b-card class="shadow-sm mb-2 bg-white rounded">
        <wizard :steps="wizardSteps" :activeIndex="wizardActiveIndex"></wizard>
        <hr />
        <b-alert v-model="showErro" variant="danger">{{
          mensagemErro
        }}</b-alert>

        <validation-observer ref="observer" v-slot="{ passes }">
          <b-form @submit.stop.prevent="passes(enviar)">

            <validation-provider
              v-if="ar.pj || ar.equipamento"
              :rules='{ required: true, regex: validInputRegex }'
              name="municipioEmpresa"
              v-slot="validationContext"
            >
              <b-form-group
                id="input-group-municipio-empresa"
                label="Município da empresa"
                label-for="input-municipio-empresa"
              >
                <b-form-input
                  id="input-municipio-empresa"
                  name="input-municipio-empresa"
                  v-model="info.companyLocality"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-municipio-empresa-live-feedback"
                  maxlength="128"
                  class="text-uppercase"
                  style="width: 340px"
                  trim
                >
                </b-form-input>
                <b-form-invalid-feedback id="input-municipio-empresa-live-feedback">
                  {{validationContext.errors[0]}}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-if="ar.pj || ar.equipamento"
              rules='required'
              name="ufEmpresa"
              v-slot="validationContext"
            >
              <b-form-group
                id="input-group-uf-empresa"
                label="UF da empresa"
                label-for="sel-uf-empresa"
              >
                <b-form-select
                  id="sel-uf-empresa"
                  name="sel-uf-empresa"
                  :options="ufs"
                  v-model.number="info.companyState"
                  :state="getValidationState(validationContext)"
                  aria-describedby="sel-uf-empresa-live-feedback">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Selecione uma opção --</b-form-select-option>
                    </template>
                </b-form-select>
                <b-form-invalid-feedback id="sel-uf-empresa-live-feedback">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <b-form-group id="ask-nomeSocial" label-for="ask-nomeSocial-cb" v-if="!ar.equipamento">
              <b-form-checkbox v-model="showNomeSocial" id="ask-nomeSocial-cb"
                >Desejo informar o nome social do responsável pelo uso do certificado.


              </b-form-checkbox>
            </b-form-group>
            <validation-provider
              v-if="showNomeSocial"
              :rules='{ regex: validInputRegex }'
              name="NomeSocial"
              v-slot="validationContext">
              <b-form-group
                id="input-group-nomeSocial"
                label="Nome social"
                label-for="input-nomeSocial"
              >
                <b-form-input
                  id="input-nomeSocial"
                  name="input-nomeSocial"
                  v-model="info.nomeSocial"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-nomeSocial-live-feedback"
                  maxlength="150"
                  class="text-uppercase"
                  trim
                >
                </b-form-input>
                <b-form-invalid-feedback id="input-nomeSocial-live-feedback">
                  {{validationContext.errors[0]}}
                </b-form-invalid-feedback>
               <b-form-text>
                 Designação pela qual a pessoa travesti ou transexual se identifica e é socialmente reconhecida.
Deve ser informado o nome social que adota, se for o caso, seguindo o disposto no Decreto nº 8.727, de 28 de abril de 2016.
Caso não queira ou não adote, deixa o campo em branco.
                </b-form-text>
              </b-form-group>
            </validation-provider>
            <b-form-group id="ask-fields" label-for="ask-fields-cb" v-if="!ar.equipamento">
              <b-form-checkbox v-model="showFields" id="ask-fields-cb"
                >Desejo informar o número do NIS e/ou CAEPF ou CEI.</b-form-checkbox
              >
            </b-form-group>
            <validation-provider
              v-if="showFields"
              rules="min:14"
              name="NIS"
              v-slot="validationContext"
            >
              <b-form-group
                id="example-input-group-1"
                :label="ar.pf ? 'NIS(NIT/PIS/PASEP)' : 'NIS(NIT/PIS/PASEP) do Representante Legal'"
                label-for="input-nis"
              >
                <b-form-input
                  id="input-nis"
                  name="input-nis"
                  v-model="info.nis"
                  v-mask="'###.#####.##-#'"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-1-live-feedback"
                  maxlength="14"
                ></b-form-input>

                <b-form-invalid-feedback id="input-1-live-feedback">{{
                  validationContext.errors[0]
                }}</b-form-invalid-feedback>
                <b-form-text>
                  Para <b>procuração eletrônica</b> no sistema
                  <b>Conectividade Social</b>.
                </b-form-text>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-if="showFields"
              rules="min:12"
              name="CAEPF"
              v-slot="validationContext"
            >
              <b-form-group
                id="example-input-group-2"
                label="CAEPF"
                label-for="input-CAEPF"
              >
                <b-form-text>
                  Coforme ICP-Brasil deverá ser preenchido apenas os
                  12 primeiros dígitos.
                </b-form-text>
                <b-form-input
                  id="input-CAEPF"
                  name="input-CAEPF"
                  v-model="info.cei"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-2-live-feedback"
                  maxlength="12"
                ></b-form-input>

                <b-form-invalid-feedback id="input-2-live-feedback">{{
                  validationContext.errors[0]
                }}</b-form-invalid-feedback>
                <b-form-text>
                  Para o uso do certificado no Sistema <b>Conectividade Social</b> o campo
                  deverá ser preenchido com o número do <b>CEI</b>.
                </b-form-text>
              </b-form-group>
            </validation-provider>
            <hr />
            <div class="botoes-wizard">
              <b-button
                onclick="history.back(-1)"
                variant="secondary"
                v-if="!loading"
                class="btn-sd mr-4"
                >Cancelar</b-button
              >
              <b-button
                type="submit"
                variant="primary"
                v-if="!loading"
                class="btn-sd"
                style="float: right"
                >Continuar</b-button
              >

              <b-button
                variant="primary"
                disabled
                v-if="loading"
                class="btn-sd"
                style="float: right"
              >
                <b-spinner small type="grow"></b-spinner>&nbsp;Enviando...
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import cabecalho from "./components/Cabecalho.vue";
import wizard from "./components/Wizard.vue";

export default {
  components: {
    cabecalho,
    wizard,
  },
  data() {
    return {
      wizardSteps: [
        "Identificação",
        "Contato",
        "Informações Adicionais",
        "Confirmação",
      ],
      wizardActiveIndex: 2,
      showFields: false,
      showNomeSocial: false,
      info: {
        companyLocality: null,
        companyState: null,
        nis: null,
        cei: null,
        nomeSocial: null,
      },
      mensagemErro: null,
      showErro: false,
      loading: false,
      validInputRegex: /^[a-zA-Z0-9 !"#$%&')(\\\\\\.\\*+,-/:;=?@]*$/,
      ufs: [
        { value: 'AC', text: 'ACRE' },
        { value: 'AL', text: 'ALAGOAS' },
        { value: 'AP', text: 'AMAPÁ' },
        { value: 'AM', text: 'AMAZONAS' },
        { value: 'BA', text: 'BAHIA' },
        { value: 'CE', text: 'CEARÁ' },
        { value: 'DF', text: 'DISTRITO FEDERAL' },
        { value: 'ES', text: 'ESPÍRITO SANTO' },
        { value: 'GO', text: 'GOIÁS' },
        { value: 'MA', text: 'MARANHÃO' },
        { value: 'MT', text: 'MATO GROSSO' },
        { value: 'MS', text: 'MATO GROSSO DO SUL' },
        { value: 'MG', text: 'MINAS GERAIS' },
        { value: 'PA', text: 'PARÁ' },
        { value: 'PB', text: 'PARAÍBA' },
        { value: 'PR', text: 'PARANÁ' },
        { value: 'PE', text: 'PERNAMBUCO' },
        { value: 'PI', text: 'PIAUÍ' },
        { value: 'RJ', text: 'RIO DE JANEIRO' },
        { value: 'RN', text: 'RIO GRANDE DO NORTE' },
        { value: 'RS', text: 'RIO GRANDE DO SUL' },
        { value: 'RO', text: 'RONDÔNIA' },
        { value: 'RR', text: 'RORAIMA' },
        { value: 'SC', text: 'SANTA CATARINA' },
        { value: 'SP', text: 'SÃO PAULO' },
        { value: 'SE', text: 'SERGIPE' },
        { value: 'TO', text: 'TOCANTINS' }
      ],
    };
  },
  computed: {
    ar: function () {
      var arAndCertificate = sessionStorage.getItem("arAndCertificate");
      if (arAndCertificate != null) {
        return JSON.parse(arAndCertificate);
      }
      return null;
    },
  },
  methods: {
    enviar: function () {
      this.loading = true;
      this.showErro = false;
      this.$http
        .put(this.$serviceUrl + "/order/additional/information", this.info, {
          headers: {
            Authorization: sessionStorage.getItem("token"),
          },
        })
        .then(
          resp => {
            sessionStorage.setItem("token", resp.bodyText);
            this.$router.replace("/order/step/confirmation");
          },
          resp => {
            if (resp.status == 404) {
              this.mensagemErro = "Não encontrado";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loading = false;
          }
        );
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
  watch: {
    showFields: function (newValue) {
      if (!newValue) {
        this.info.nis = null;
        this.info.cei = null;
      }
    },
    showNomeSocial: function (newValue) {
      if (!newValue) {
        this.info.nomeSocial = null;
      }
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/AdditionalInformation.vue